import { Play } from "lucide-react";

import { Card, CardContent } from "@/components/ui/card";
import type { Video } from "@/model/videos";

type VideoListItemProps = {
  video: Video;
  onSelect: () => void;
  testId?: string;
};

const VideoListItem = ({ video, onSelect, testId }: VideoListItemProps) => (
  <button
    type="button"
    onClick={onSelect}
    aria-label={`Play ${video.topic}`}
    data-testid={testId}
    className="group text-left"
  >
    <Card className="h-full overflow-hidden transition-shadow group-hover:shadow-md">
      <div className="relative aspect-video w-full bg-black">
        <img
          src={video.thumbNail}
          alt={video.topic}
          className="size-full object-cover"
        />
        <span className="absolute inset-0 flex items-center justify-center bg-black/20 transition-colors group-hover:bg-black/40">
          <span className="flex size-12 items-center justify-center rounded-full bg-white/90 shadow-md">
            <Play className="ml-0.5 size-5 fill-current text-foreground" />
          </span>
        </span>
      </div>

      <CardContent className="p-4">
        <p className="font-medium">{video.topic}</p>
        <p className="text-sm text-muted-foreground">
          {video.source} · {video.type}
        </p>
      </CardContent>
    </Card>
  </button>
);

export default VideoListItem;
